import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

const useGetExtractionBatch = (
  dataPoolId: string,
  extractionBatchId: string,
  enabled: boolean = true,
  interval?: number
) => {
  const glynt = useGlynt(dataPoolId);

  return useQuery({
    queryKey: ['extractionBatch', extractionBatchId],
    queryFn: async () => await (await glynt).extractionBatch.retrieve(extractionBatchId),
    ...(interval ? { refetchInterval: interval } : {}),
    refetchOnWindowFocus: false,
    enabled: enabled
  });
};

export default useGetExtractionBatch;
